export class Config {
    public static API_ENDPOINT = '/api';
}
